import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import React from "react";

import { Box, Overlay } from "~/components/blocks";

type Props = {
  open: boolean;
  children: React.ReactNode;
};

const Wrapper = styled("div")(({ theme }) =>
  css({
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.space.l,
  }),
);

const ModalRoot = styled("div")(({ theme }) =>
  css({
    position: "relative",
    maxWidth: "720px",
    maxHeight: "90vh",
    backgroundColor: theme.colors.background.default,
    padding: `${theme.space.l} ${theme.space.xl}`,
    border: theme.borders.default,
    borderRadius: theme.radii.default,
    boxShadow: theme.shadows.default,
    overflow: "auto",
  }),
);

export const Modal: React.VFC<Props> = React.memo((props) => {
  return (
    <Overlay open={props.open}>
      <Wrapper>
        <ModalRoot>
          <Box height="100%" overflow="auto">
            {props.children}
          </Box>
        </ModalRoot>
      </Wrapper>
    </Overlay>
  );
});

Modal.displayName = "Modal";
